import React from "react";
import { Card, Col } from "react-bootstrap";
import { AiFillStar } from "react-icons/ai";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import UseAddFavorite from "./../../CustomHooks/Favorite/UseAddFavorite"
import UseLogged from "../../CustomHooks/Auth/UseLogged";

const ProductCard = ({ item, favList }) => {
  const [handleFav, FavImage] = UseAddFavorite(item, favList)
  const [isLogin, LogOut, role, token] = UseLogged()
  return (
    <Col xs="12" sm="6" xl="3" lg="4" className="d-flex">
      <Card className="my-4 w-100 shadow border-0">
        <Link to={`/product/${item._id}`} className="justify-content-center d-flex">
          <Card.Img src={item.imageCover} />

        </Link>
        {role && role === "admin" ? (
          null
        ) : <div className="d-flex justify-content-end mx-2 pointer-cursor">
          <span onClick={handleFav}>
            {FavImage}
          </span>
        </div>}

        <Card.Body className="gray-bg">
          <Card.Title>
            <div className="fw-bold fs-20 my-4">
              {item.title}
            </div>
          </Card.Title>
          <Card.Text>
            <div className="d-flex justify-content-between ">
              <div className="d-flex align-items-center">
                {item.ratingsAverage ? (<>
                  <AiFillStar className="yellow-color fs-20" />
                  <div className="mx-2 fs-20">{item.ratingsAverage}</div>
                </>) : null}

              </div>
              <div className="d-flex align-items-center">
              {item.priceAfterDiscount ? (<><span className="me-2 orange-color fw-bold fs-20">{item.priceAfterDiscount} EGP</span> <del className="fs-16 mt-2">{item.price} EGP</del></>) : <p className="fw-bold fs-20 mb-0  orange-color me-2"> {item.price} EGP</p>}
              </div>
            </div>
          </Card.Text>
        </Card.Body>
      </Card>
      <ToastContainer />
    </Col>
  );
};

export default ProductCard;
